import React, { useEffect, useRef, useState } from "react";
import { Box, Drawer, Typography } from "@mui/material";
import { minutesToHoursAndMinutes } from "../utilities/helperfunctions";
import packageJson from "../../package.json";
import {
  MenuHandle,
  FlightsPanel,
  NavigationPanel,
  useVersionUpdateStatus,
  useGroupedFlights,
  useMenuSearch,
  useExpandedDatesState,
  useEnsureSelectedVisible,
} from "./SlideOutMenu/index.js";

export const SlideOutMenuNew = (props) => {
  const [search, setSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(
    typeof props.activeIndex === "number" ? props.activeIndex : null
  );

  const listRootRef = useRef(null);
  const handleRef = useRef(null);

  const open = props.openMenu === props.title;
  const setOpen = (isOpen) => {
    if (isOpen) {
      props.onMenuToggle?.(props.title);
    } else {
      props.onMenuToggle?.(null);
    }
  };
  const toggleOpen = () => {
    props.onMenuToggle?.(props.title);
  };

  useEffect(() => {
    if (typeof props.activeIndex === "number") {
      setActiveIndex(props.activeIndex);
    }
  }, [props.activeIndex]);

  const { shouldRefresh, isReloading, clearCacheAndReload } =
    useVersionUpdateStatus();

  const groups = useGroupedFlights(
    !!props.flightMenu,
    props.menuItems,
    props.isTrainingMode
  );
  const filteredGroups = useMenuSearch(groups, search);
  const visibleGroups = search.trim() ? filteredGroups : groups;

  const { expandedDates, handleAccordionChange, expandAll, collapseAll } =
    useExpandedDatesState(!!props.flightMenu, groups, props.selectedFlightId);

  // Auto-scroll selected item into view
  useEnsureSelectedVisible(open, !!props.flightMenu, groups, listRootRef);

  const anchor = props.side === "right" ? "right" : "left";
  const isOtherMenuOpen = !!(props.openMenu && props.openMenu !== props.title);

  const calcStopTime = (departureDateTime, arrivalDateTime) => {
    return minutesToHoursAndMinutes(
      Math.max(
        0,
        Math.round(
          (new Date(departureDateTime) - new Date(arrivalDateTime)) /
            (1000 * 60)
        )
      )
    );
  };

  return (
    <>
      <MenuHandle
        title={props.title}
        anchor={anchor}
        open={open}
        toggleOpen={toggleOpen}
        isOtherMenuOpen={isOtherMenuOpen}
        topPosition={props.topPosition}
        backgroundColor={props.backgroundColor}
        height={props.height}
        maxHeight={props.maxHeight}
        handleRef={handleRef}
      />
      <Drawer
        anchor={anchor}
        open={open}
        onClose={() => {
          setOpen(false);
          requestAnimationFrame(() => {
            if (handleRef.current) {
              handleRef.current.focus();
            }
          });
        }}
        ModalProps={{ keepMounted: true }}
        transitionDuration={{ enter: 150, exit: 120 }}
        sx={{
          zIndex: (theme) =>
            theme.zIndex.modal + (props.title === "flights" ? 2 : 1) - 1,
        }}
      >
        {props.menuItems ? (
          props.flightMenu ? (
            <FlightsPanel
              search={search}
              setSearch={setSearch}
              visibleGroups={visibleGroups}
              expandedDates={expandedDates}
              handleAccordionChange={handleAccordionChange}
              expandAll={expandAll}
              collapseAll={collapseAll}
              listRootRef={listRootRef}
              isCabinCrew={props.isCabinCrew}
              isTrainingMode={props.isTrainingMode}
              onTrainingModeChange={props.onTrainingModeChange}
              selectedFlightId={props.selectedFlightId}
              changeFlight={props.changeFlight}
              changeCrewType={props.changeCrewType}
              shouldRefresh={shouldRefresh}
              isReloading={isReloading}
              clearCacheAndReload={clearCacheAndReload}
              setOpen={setOpen}
              calcStopTime={calcStopTime}
              appVersion={packageJson.version}
            />
          ) : (
            <NavigationPanel
              menuItems={props.menuItems}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              shouldRefresh={shouldRefresh}
              isReloading={isReloading}
              clearCacheAndReload={clearCacheAndReload}
              navigate={props.navigate}
              setOpen={setOpen}
              appVersion={packageJson.version}
              checkboxes={props.checkboxes}
              cleaningCheckUrl={props.cleaningCheckUrl}
              cleaningCheckDisabled={props.cleaningCheckDisabled}
            />
          )
        ) : (
          <Box
            sx={{
              width: 280,
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="body2">Loading...</Typography>
          </Box>
        )}
      </Drawer>
    </>
  );
};
